import { fork, all } from 'redux-saga/effects'
import { getParamsForPostSet, getParamsForFollowersSet, getFollowing, getPostIds, getKitsCreated } from './sagas'
import { processSaga, watchSaga, chainSagas } from '../workflow'
import actionTypes from '../../actionTypes' // eslint-disable-line import/no-named-as-default, temporary until we only export the one thing
import setPost from '../../../dataservices/setPost'
import setPostHideFromFeed from '../../../dataservices/setPostHideFromFeed'
import getKitByKitId from '../../../dataservices/getKitByKitId'
import getPostByPostId from '../../../dataservices/getPostByPostId'
import setPostKudos from '../../../dataservices/setPostKudos'
import getPostKudos from '../../../dataservices/getPostKudos'
import actionWorkflows from '../../actionWorkflows'
import deletePostByPostId from '../../../dataservices/deletePostByPostId'
import setUserProfileFollower from '../../../dataservices/setUserProfileFollower'

const postFetchingActions = [
	actionTypes.postFetch_Success,
	actionTypes.feedFetch_Success
]

const postSetWorkflow = processSaga.bind(null, actionWorkflows.postSet, setPost)
const postFetchWorkflow = processSaga.bind(null, actionWorkflows.postFetch, getPostByPostId)
const postDraftFetchWorkflow = processSaga.bind(null, actionWorkflows.postDraftFetch, getPostByPostId)
const kitFetchWorkflow = processSaga.bind(null, actionWorkflows.postDraftKitFetch, getKitByKitId)
const postDraftUserKitsFetchWorkflow = processSaga.bind(null, actionWorkflows.postDraftUserKitsFetch, getKitsCreated)
const postKudosSetWorkflow = processSaga.bind(null, actionWorkflows.kudosPostSet, setPostKudos)
const postDeleteWorkflow = processSaga.bind(null, actionWorkflows.postDelete, deletePostByPostId)
const followersSetWorkflow = processSaga.bind(null, actionWorkflows.postFollowersSet, setUserProfileFollower)
const postHideFromFeedSetWorkflow = processSaga.bind(null, actionWorkflows.postHideFromFeedSet, setPostHideFromFeed)
const postFetchFollowingWorkflow = processSaga.bind(null, actionWorkflows.postFetchFollowing, getFollowing)
const postFetchChain = chainSagas.bind(null, [postFetchWorkflow, postFetchFollowingWorkflow])
const postKudosFetchWorkflow = processSaga.bind(null, actionWorkflows.kudosPostUserFetch, getPostKudos)

export default function* root() {
	yield all([
		fork(watchSaga.bind(null, actionTypes.postSet, postSetWorkflow, { latest: true, selectParams: getParamsForPostSet })),
		fork(watchSaga.bind(null, actionTypes.postHideFromFeedSet, postHideFromFeedSetWorkflow, { latest: true })),
		fork(watchSaga.bind(null, actionTypes.postDraftKitFetch, kitFetchWorkflow, { latest: true })),
		fork(watchSaga.bind(null, actionTypes.postDraftUserKitsFetch, postDraftUserKitsFetchWorkflow, { latest: true })),
		fork(watchSaga.bind(null, actionTypes.kudosPostSet, postKudosSetWorkflow)),
		fork(watchSaga.bind(null, actionTypes.postFollowersSet, followersSetWorkflow, { selectParams: getParamsForFollowersSet })),
		fork(watchSaga.bind(null, actionTypes.postFetch, postFetchChain, { latest: true })),
		fork(watchSaga.bind(null, actionTypes.postDraftFetch, postDraftFetchWorkflow, { latest: true })),
		fork(watchSaga.bind(null, actionTypes.postDelete, postDeleteWorkflow)),
		fork(watchSaga.bind(null, postFetchingActions, postKudosFetchWorkflow, { selectParams: getPostIds }))
	])
}



// WEBPACK FOOTER //
// ./src/redux/saga/posts/index.js